import { css } from 'aphrodite';
import * as React from 'react';
import { useState } from 'react';
import { useHistory } from 'react-router';
import { FetchStatus } from '../../entities/utils/useStatesOnFetch';
import { ContentBox } from '../generics/ContentBox';
import { Group } from '../leadView/components/Group';
import { useIntegrationProperties } from './IntegrationPropertiesContext';
import { AddPropertiesButton } from './components/AddPropertiesButton';
import { ICheckboxListItem } from './components/CheckboxList';
import { EmptyState, EmptyStateVariations } from './components/EmptyState';
import { LeadAddPropertyList } from './components/LeadAddPropertyList';
import { LeadPropertyCard } from './components/LeadPropertyCard';
import { PropertyItemRow } from './components/PropertyItemRow';
import { SelectedTagsContainer } from './components/SelectedTagsContainer';
import { styleSheet } from './styles';

let savedItems: ICheckboxListItem[] = null;

export const AddLeadProperties: React.FC = () => {
	const [isAdding, setAdding] = useState(false);

	const [selectedItems, setSelected] = useState<ICheckboxListItem[]>(null);

	const history = useHistory();

	const { config, status, update } = useIntegrationProperties();

	const moveToSaveOrClear = () => {
		setAdding(!isAdding);
		savedItems = selectedItems;
	};

	const cancelAndGoBack = () => {
		history.push('/integration/lead-properties');
	};

	const handleSelectedProperties = (items: ICheckboxListItem[]) => {
		setSelected(items);
	};

	const handleSave = () => {
		if (!config || !config.properties) {
			return;
		}

		selectedItems?.forEach(x => {
			config.properties.find(prop => prop.name === x.content.name).addAsTag = true;
		});

		update({ ...config, properties: config.properties }, cancelAndGoBack);
	};

	const handleClear = () => {
		setAdding(false);
		setSelected(savedItems);
	};

	const handleRemoveFromSelected = (item: ICheckboxListItem) => () => {
		const newValues = [...selectedItems].filter(i => i.id !== item.id);
		setSelected(newValues);
	};

	const updateCheckboxOnSelected =
		(item: ICheckboxListItem) =>
		({ target }: React.ChangeEvent<HTMLInputElement>) => {
			const newValues = [...selectedItems].map(i => {
				if (i.id === item.id) {
					i.content.addToForm = target.checked;
				}
				return i;
			});
			setSelected(newValues);
		};

	return (
		<Group>
			<ContentBox
				className={css(styleSheet.addPropertiesContentBox)}
				maxWidth={430}
				title="Select the Hubspot properties you'd like to add below:"
				titleAlignment='center'
			>
				<LeadAddPropertyList
					defaultValues={config?.properties}
					isAdding={isAdding}
					isLoading={status !== FetchStatus.Done}
					onSelect={handleSelectedProperties}
				/>
			</ContentBox>

			<AddPropertiesButton
				disabled={!selectedItems || selectedItems?.length <= 0}
				isAdding={isAdding}
				onClickToAdd={moveToSaveOrClear}
				onClickToCancel={cancelAndGoBack}
			/>

			<ContentBox
				className={css(styleSheet.addPropertiesContentBox)}
				isBlocked={status === FetchStatus.Working}
				maxWidth={430}
				title='They will be turned into tags in Coffee:'
				titleAlignment='center'
			>
				{isAdding ? (
					<SelectedTagsContainer onClickToSave={handleSave} onClickToClear={handleClear}>
						{selectedItems?.map(item => {
							return (
								<PropertyItemRow
									key={item.id}
									onClickToRemove={handleRemoveFromSelected(item)}
									renderLeft={
										<LeadPropertyCard
											checked={item.content.addToForm}
											onCheckboxChange={updateCheckboxOnSelected(item)}
											tagLabel={item.label}
										/>
									}
								/>
							);
						})}
					</SelectedTagsContainer>
				) : (
					<EmptyState variation={EmptyStateVariations.Tags} />
				)}
			</ContentBox>
		</Group>
	);
};
